/**
 * @docs docs/features/website-navigation-shell
 */

/*----------------------------------
- MEGA MENU PANEL
----------------------------------*/

import type { ComponentChildren } from 'preact';

/*----------------------------------
- TYPES
----------------------------------*/

type MegaMenuPanelProps = {
    id: string;
    testId: string;
    isOpen: boolean;
    /**
     * One width per menu, as drawn (mock parity web-recheck-05): Domains (`mm-wide`, its columns 2fr 1fr 1fr) and Market
     * (`mm-medium`) share one 1040px frame opening in the same place under the nav; Tools (`mm-narrow`) is 700px under
     * its trigger.
     */
    width?: 'wide' | 'medium' | 'narrow';
    /** The panel's columns: one `MegaMenuSection` each, a hairline between two. */
    children: ComponentChildren;
};

/*----------------------------------
- COMPONENT
----------------------------------*/

/**
 * The floating card every desktop megamenu opens in: the marketing layer's `.mm` (placed 16px under the nav, its
 * entrance and its reduced-motion rule in `marketing.css`) around the system's pop-up frame `.mm-card`, which lays its
 * sections out as columns. No head since the redraw of 2026-11-02 (web-recheck-01 to 03): a panel opens straight on its
 * columns. Closed panels stay in the document (`hidden`) so their links remain crawlable.
 */
export default function MegaMenuPanel({ id, testId, isOpen, width = 'wide', children }: MegaMenuPanelProps) {
    return (
        <div id={id} class={`mm mm-${width}`} data-testid={testId} hidden={!isOpen} aria-hidden={!isOpen}>
            <div class="mm-card">{children}</div>
        </div>
    );
}
